module.exports = __webpack_public_path__ + "static/media/undraw_checking_boxes_2ibd.b3ef092a.svg";